import { useEffect, useState } from 'react';

/**
 * `value`, but only after it has stopped changing for `delayMs`. Used by
 * the contacts search so each keystroke doesn't fire its own request
 * (review fix 25/9).
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);
  return debounced;
}
